/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import Head from 'next/head';

import JsonRecipeContent from './JsonRecipeContent';
import FallbackImage from '../../inline-images/post-fallback-image.jpg';

export default function SingleRecipeJsonLd({ recipe, siteUrl }) {
	const recipeContent = new JsonRecipeContent(recipe);
	const description = recipeContent.getDesription();
	const image = recipeContent.convertImageToJsonLdArry();
	const author = recipeContent.getAuthor();
	const getPrepSteps = recipeContent.convertPrepStepsToJsonLdArry(siteUrl);
	const prepTime = recipeContent.wrapWithTimeQuotes(recipeContent.getPrepTime());
	const cookTime = recipeContent.wrapWithTimeQuotes(recipeContent.getCookTime());
	const totalTime = recipeContent.wrapWithTimeQuotes(recipeContent.getTotalTime());
	const recipeCategory = recipeContent.getRecipeCategory();
	const recipeCuisine = recipeContent.getRecipeCuisine();
	const ingrediants = recipeContent.getIngredients();
	const recipeYield = recipeContent.getYield();
	const aggregateRating = recipeContent.getAggregateRating();
	const fallbackImage = (
		((siteUrl[siteUrl.length - 1] === '/')
			? siteUrl.substr(0, siteUrl.length - 1)
			: siteUrl)
		+ FallbackImage.src
	);

	return (
		<Head>
			<script
				id="recipe-ld-json"
				type="application/ld+json"
				dangerouslySetInnerHTML={{
					__html: `{
						"@context": "https://schema.org/",
						"@type": "Recipe",
						"name": "${recipe.title}",
						"datePublished": "${recipe.date}",
						"description": ${description},
						"author": {
							"@type": "Person",
							"name": ${author || '"Flavour Network"'}
						},
						"prepTime": ${prepTime},
						"cookTime": ${cookTime},
						"totalTime": ${totalTime},
						"recipeCategory": ${recipeCategory},
						"recipeCuisine": ${recipeCuisine},
						"recipeIngredient": [${ingrediants}],
						"recipeYield": ${recipeYield},
						"recipeInstructions": [${getPrepSteps}],
						"image": ${image || `"${fallbackImage}"`},
						"aggregateRating": ${aggregateRating}
					}`,
				}}
			/>
		</Head>
	);
}

SingleRecipeJsonLd.propTypes = {
	recipe: PropTypes.object.isRequired,
	siteUrl: PropTypes.string.isRequired,
};
